document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[id^="aura-ugc-gallery-"].aug').forEach(initAug);
});

function initAug(root){
    const viewport = root.querySelector('.aug__viewport');
    const track = root.querySelector('.aug__track');
    const pauseOnHover = root.dataset.pause === 'true';
    const duration = parseFloat(root.dataset.duration || 22);

    const originals = Array.from(track.children).map(n => n.cloneNode(true));

    // gallery state
    const state = {
        scrollPaused: false,
        soloVideo: null // the one currently unmuted (if any)
    };

    function setScrollPaused(paused){
        state.scrollPaused = paused;
        track.style.animationPlayState = paused ? 'paused' : 'running';
        root.classList.toggle('is-scroll-paused', paused);
    }

    function tryAutoplay(v){
        v.muted = true;
        v.playsInline = true;
        v.autoplay = true;
        // nudge the engine to (re)load if needed
        if (v.readyState < 1) v.load?.();
        return v.play ? v.play().then(()=>true).catch(e=>{
            if (e && e.name === 'NotAllowedError') return false;
                return false;
        }) : Promise.resolve(false);
    }

    function bootstrapOnFirstGesture(cb){
        const once = () => {
            window.removeEventListener('pointerdown', once, true);
            window.removeEventListener('touchstart', once, true);
            window.removeEventListener('keydown', once, true);
            cb();
        };
        window.addEventListener('pointerdown', once, true);
        window.addEventListener('touchstart', once, true);
        window.addEventListener('keydown', once, true);
    }

    function hydrateVideos(scope){
        scope.querySelectorAll('video').forEach(video=>{
            const item = video.closest('.aug__item');
            if (!item) return;
            item.classList.remove('is-loaded');

            video.muted = true; video.loop = true; video.playsInline = true; video.autoplay = true;
            if (video.play) video.play().catch(()=>{});

            const MIN_TIME = 0.15; // seconds progressed before we consider it "playing"
            const MIN_SPIN = 250;  // ms min spinner visibility to avoid blinking
            const t0 = performance.now();

            const hide = () => {
                const dt = performance.now() - t0;
                const delay = Math.max(0, MIN_SPIN - dt);
                setTimeout(()=> item.classList.add('is-loaded'), delay);
            };

            // Helper: confirm both time has advanced and (where supported) a frame was painted
            let sawTime = false, sawFrame = false, done = false;

            function maybeHide(){
                if (done) return;
                if (sawTime && (sawFrame || !('requestVideoFrameCallback' in HTMLVideoElement.prototype))){
                    done = true;
                    hide();
                }
            }

            const timeCheck = () => {
                if (!video.paused && video.currentTime >= MIN_TIME){
                    sawTime = true;
                    maybeHide();
                }
            };
            const timeIv = setInterval(()=>{
                timeCheck();
                if (sawTime || video.ended) clearInterval(timeIv);
            }, 50);

            if (typeof video.requestVideoFrameCallback === 'function'){
                const onFrame = () => {
                    sawFrame = true;
                    maybeHide();
                };
                const loop = () => {
                    if (!sawFrame) video.requestVideoFrameCallback(()=>{ onFrame(); });
                };
                video.requestVideoFrameCallback(()=>{ onFrame(); });
                const frameIv = setInterval(()=>{
                    if (!sawFrame) loop(); else clearInterval(frameIv);
                }, 100);
            }
            setTimeout(()=>{
                if (!done) { sawTime = true; maybeHide(); }
            }, 18000);
        });
    }

    function pauseAllExcept(target){
        track.querySelectorAll('video').forEach(v=>{
            if (v === target){
                v.muted = false;
                v.play().catch(()=>{});
            } else {
                v.muted = true;
                v.pause();
            }
        });
    }

    function resumeAllMuted(){
        track.querySelectorAll('video').forEach(v=>{
        v.muted = true;
        v.play().catch(()=>{});
        });
    }

    function wireInteractions(){
        // Tap/click ANY card toggles solo mode for that card + scroll pause
        track.querySelectorAll('.aug__item').forEach(item=>{
        const video = item.querySelector('video');
        item.addEventListener('click', (e)=>{
            // if this card is already solo → revert
            if (state.soloVideo === video){
            state.soloVideo = null;
            resumeAllMuted();
            setScrollPaused(false);
            } else {
            state.soloVideo = video;
            pauseAllExcept(video);
            setScrollPaused(true);
            }
        }, { passive: true });
        });

        if (pauseOnHover){
        root.addEventListener('mouseenter', ()=> { if (!state.soloVideo) setScrollPaused(true); });
        root.addEventListener('mouseleave', ()=> { if (!state.soloVideo) setScrollPaused(false); });
        }
    }

    function build(){
        // (re)build two equal cycles
        track.innerHTML = '';
        const frag = document.createDocumentFragment();
        originals.forEach(n => frag.appendChild(n.cloneNode(true)));
        track.appendChild(frag);

        // fill to viewport at least once
        const minWidth = viewport.clientWidth + 1;
        let guard = 0;
        while (track.scrollWidth < minWidth && guard < 20){
        originals.forEach(n => track.appendChild(n.cloneNode(true)));
        guard++;
        }

        const baseCount = track.children.length;
        const baseWidth = track.scrollWidth;

        // duplicate once to make seamless loop
        for (let i = 0; i < baseCount; i++){
        track.appendChild(track.children[i].cloneNode(true));
        }

        // set animation variables
        track.style.setProperty('--aug-shift', baseWidth + 'px');
        track.style.setProperty('--aug-duration', (isNaN(duration) ? 22 : duration) + 's');

        hydrateVideos(track);

        // attempt muted autoplay immediately
        Promise.all(Array.from(track.querySelectorAll('video')).map(tryAutoplay)).then(results=>{
        // if any were blocked in Safari, arm a once-only gesture bootstrap
            if (results.some(ok => !ok)) {
                bootstrapOnFirstGesture(() => {
                    track.querySelectorAll('video').forEach(v => { tryAutoplay(v); });
                });
            }
        });
        const io = new IntersectionObserver((entries)=>{
            if (entries.some(e => e.isIntersecting)) {
                track.querySelectorAll('video').forEach(v => { tryAutoplay(v); });
                io.disconnect();
            }
        });
        io.observe(root);
        wireInteractions();
    }

    const ro = new ResizeObserver(build);
    ro.observe(viewport);
    build();
}